import { IGetAllAvaliacaoTreinamentoLoteUseCase } from "../../../presentation/useCases/read/get_all_avaliacao_treinamento_lote_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AvaliacaoTreinamento } from "../../models/avaliacao_treinamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllAvaliacaoTreinamentoLoteUseCase
 */

export class GetAllAvaliacaoTreinamentoLoteUseCase
  extends BasePaginatedUseCase<AvaliacaoTreinamento>
  implements IGetAllAvaliacaoTreinamentoLoteUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllAvaliacaoTreinamentoLote(
    idCargo: number | null,
    idFuncionario: number | null,
    idCentroCusto: number[] | null,
    vencimentoDe: Date | null,
    vencimentoAte: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllAvaliacaoTreinamentoLote(
      idCargo,
      idFuncionario,
      idCentroCusto,
      vencimentoDe,
      vencimentoAte,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
